import { ApiClient } from './ApiClient';
import { ApiConnector } from '_helpers';
import apiConfig from '../config/apiConfig.default';

const apiConnector = new ApiConnector(ApiClient, apiConfig);

export default apiConnector;
